import React from 'react';
import Image from '../../../components/AppImage';
import { useLanguage } from '../../../contexts/LanguageContext';
import { AnimateOnScroll } from './AnimateOnScroll';

const TrustLogoStrip = () => {
  const { t } = useLanguage();

  const clientLogos = [
    {
      id: 1,
      name: 'TechCorp Solutions',
      logo: 'https://img.rocket.new/generatedImages/rocket_gen_img_1e804efd4-1765889399451.png',
      alt: 'TechCorp Solutions logo',
    },
    {
      id: 2,
      name: 'Global Industries',
      logo: 'https://img.rocket.new/generatedImages/rocket_gen_img_167d7cfd4-1764659144088.png',
      alt: 'Global Industries logo',
    },
    {
      id: 3,
      name: 'Innovation Labs',
      logo: 'https://img.rocket.new/generatedImages/rocket_gen_img_1e9d64359-1764654562173.png',
      alt: 'Innovation Labs logo',
    },
    {
      id: 4,
      name: 'Enterprise Systems',
      logo: 'https://img.rocket.new/generatedImages/rocket_gen_img_116254b71-1764745397565.png',
      alt: 'Enterprise Systems logo',
    },
    {
      id: 5,
      name: 'Digital Ventures',
      logo: 'https://img.rocket.new/generatedImages/rocket_gen_img_10dbd7105-1764654562894.png',
      alt: 'Digital Ventures logo',
    },
    {
      id: 6,
      name: 'Smart Solutions',
      logo: 'https://img.rocket.new/generatedImages/rocket_gen_img_137e5768a-1764661621135.png',
      alt: 'Smart Solutions logo',
    },
  ];

  return (
    <section className="bg-slate-100 dark:bg-slate-900/60 border-y border-border/60 py-6 md:py-8 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <AnimateOnScroll>
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
            <p className="text-xs md:text-sm font-bold tracking-widest text-amber-600 dark:text-amber-400 uppercase text-center">
              {t('home.trust.trustedBy') || 'Trusted By 678+ Organizations Worldwide'}
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 items-center">
            {clientLogos.map((client) => (
              <div
                key={client.id}
                className="bg-card/80 backdrop-blur-sm rounded-xl p-3 md:p-4 flex items-center justify-center border border-border/60 shadow-xs hover:shadow-md hover:border-amber-500/30 transition-all duration-300 group aspect-[3/2]"
              >
                <div className="w-full h-full overflow-hidden rounded-lg">
                  <Image
                    src={client.logo}
                    alt={client.alt}
                    className="w-full h-full object-cover grayscale opacity-75 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                  />
                </div>
              </div>
            ))}
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default TrustLogoStrip;
